/**
 * @Description 指标热力--选址详情和点位测评都引用
 */
import { getHeatMap, getHeatMapShare } from '@/common/api/recommend';
import { FC, useEffect, useRef, useState } from 'react';

const HeatMap:FC<any> = ({
  mapIns,
  active,
  detail,
  tenantId,
  isShare,
  shareParams,
}) => {
  const [heatData, setHeatData] = useState<any>([]);// 热力数据
  const [zoom, setZoom] = useState<number>(0);
  const heatMapRef = useRef<any>(null);// 热力实例
  const activeRef = useRef(active);

  const getHeatMapData = async() => {
    const api = tenantId || isShare && (!shareParams?.token) ? getHeatMapShare : getHeatMap;
    const { urls: CDNList } = await api({
      lng: detail.lng,
      lat: detail.lat,
      level: 5,
      levelType: 2,
      ...active?.basicParams || {}
    });
    const responses = await Promise.allSettled(CDNList.map(url => fetch(url)));
    const dataArrays = responses.map(response => {
      if (response.status === 'fulfilled' && response.value.status === 200) {
        return response.value.json(); // 成功时解析 JSON
      } else {
        return null; // 或者返回一个默认值
      }
    });
    const data = await Promise.all(dataArrays.filter(data => data !== null));
    // 打平数据
    const res = data.flat();
    let _res:any = [];
    // 遍历排除范围外的数据
    for (let i = 0; i < res.length; i++) {
      const cur = res[i];
      const tempDis = window.AMap.GeometryUtil.distance([cur.longitude, cur.latitude], [detail.lng, detail.lat]); // 直线
      tempDis < (activeRef.current?.radius || 0) && _res.push(cur);
    }
    // 对数据进行字段重整、排序
    _res = _res.map((item) => ({
      lng: item?.longitude,
      lat: item?.latitude,
      count: item?.heatCount
    })).sort((a, b) => b.count - a.count);
    setHeatData(_res);
  };
  const handleZoomEnd = () => {
    const zoom = mapIns.getZoom();
    setZoom(zoom);
  };
  const handleZoomStart = () => {
    heatMapRef.current?.hide();
  };
  // 当选中后获取热力数据
  useEffect(() => {
    activeRef.current = active;
    if (!active.keyName) {
      setHeatData([]);
    } else {
      getHeatMapData();
    }
  }, [active]);

  // 初始化，创建热力实例、监听zoom
  useEffect(() => {
    if (!mapIns) return;
    mapIns.plugin(['AMap.HeatMap'], function() {
      heatMapRef.current = new window.AMap.HeatMap(mapIns, {
        radius: 15,
        opacity: [0, 0.85],
        gradient: {
          1: '#DE312B',
          0.9: '#DE312B',
          0.8: '#FC6A17',
          0.65: '#FDFF5D',
          0.5: '#55DC4C',
          0.4: '#7DF8FF',
          0.3: '#5771EC',
        },
      });
    });

    mapIns.on('zoomend', handleZoomEnd);
    mapIns.on('zoomstart', handleZoomStart);

    return () => {
      mapIns.off('zoomend', handleZoomEnd);
      mapIns.off('zoomstart', handleZoomStart);
    };
  }, [mapIns]);

  // 热力数据得到后渲染
  useEffect(() => {
    if (!heatData.length) {
      heatMapRef.current?.hide();
      heatMapRef.current?.setDataSet({ data: [] });
      return;
    };
    heatMapRef.current?.show();
    heatMapRef.current?.setDataSet({ data: heatData, max: heatData[Math.floor(heatData?.length / 100)].count });
  }, [heatData]);
  useEffect(() => {
    let radius = 15;
    if (zoom < 15) {
      radius = 5 + (zoom - 13.5) * 4;
    } else if (zoom < 16 && zoom >= 15) {
      // 15~16
      radius = 11 + (zoom - 15) * 9;
    } else if (zoom < 17 && zoom >= 16) {
      // 16~17
      radius = 20 + (zoom - 16) * 15;
    } else if (zoom >= 17 && zoom < 18) {
      // 17~20
      radius = 35 + (zoom - 17) * 30;
    } else if (zoom >= 18) {
      radius = 65 + (zoom - 18) * 60;
    }
    heatMapRef.current?.setOptions({ radius: radius < 9 ? 9 : radius });
    heatMapRef.current?.show();
  }, [zoom]);

  return <div>

  </div>;
};
export default HeatMap;
